import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RolesUsuario } from '../../enumeraciones/roles-usuario.enum';
import { AuthService } from '../../services/auth.service';
import { environment } from 'src/environments/environment';

const VERSION = environment.version;
@Component({
	selector: 'app-ruta-no-existe',
	templateUrl: './ruta-no-existe.component.html',
	styleUrls: ['./ruta-no-existe.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class RutaNoExisteComponent implements OnInit {
	tipo_administrador_cc = RolesUsuario.AdministradorCC;
  tipo_administrador_super = RolesUsuario.AdministradorSuper;
  version = VERSION;

	constructor(public authService: AuthService) { }

	ngOnInit() {
	}

}
